module.exports = __webpack_public_path__ + "01_very_short_gold.913b82c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_very_short_gold.png
// module id = lAlN
// module chunks = 0